import type { RouteSummary } from '@viaja/contracts';
import { RouteCard } from '@viaja/design-system';
import { Link } from 'react-router-dom';
import { routeDates } from '../../lib/format';

/**
 * Item de lista de rota: o RouteCard do design system dentro de um link.
 * Sem preço ainda (fonte sem voo ou erro), mostra o mesmo cartão sem a linha de preço.
 */
export function RouteItem({ route }: { route: RouteSummary }) {
  const { latest } = route;
  const dates = routeDates(route.outboundDate, route.returnDate);
  const label = `${route.origin.city} para ${route.destination.city}, ${dates}`;
  return (
    <li>
      <Link to={`/rotas/${route.id}`} className="app-cardlink" aria-label={label}>
        {latest ? (
          <RouteCard
            origin={route.origin.city}
            destination={route.destination.city}
            dates={dates}
            price={latest.price}
            level={route.targetPrice && latest.price <= route.targetPrice ? 'target' : latest.level}
            {...(route.targetPrice ? { target: route.targetPrice } : {})}
            {...(route.chance && route.targetPrice && latest.price > route.targetPrice
              ? { chance: route.chance.chance }
              : {})}
            alertOn={route.alertEnabled && route.status === 'active'}
            trend={route.trend}
          />
        ) : (
          <article className="vc-card vc-route">
            <header className="vc-route-head">
              <span className="display-section">
                {route.origin.city} → {route.destination.city}
              </span>
            </header>
            <p className="small vc-muted">{dates}</p>
            <p className="small">Ainda sem preço para essa busca.</p>
          </article>
        )}
      </Link>
    </li>
  );
}
